import { render } from "./StepUpload.vue?vue&type=template&id=30bdd2dc&scoped=true"
import script from "./StepUpload.vue?vue&type=script&lang=js"
export * from "./StepUpload.vue?vue&type=script&lang=js"

import "./StepUpload.vue?vue&type=style&index=0&id=30bdd2dc&lang=css"
import "./StepUpload.vue?vue&type=style&index=1&id=30bdd2dc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30bdd2dc"]])

export default __exports__